"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopperProvider = exports.PopperContext = exports.PopperConsumer = void 0;
var _react = require("react");
var _constants = require("../constants");
var PopperContext = exports.PopperContext = /*#__PURE__*/(0, _react.createContext)({
  zIndex: _constants.ZINDEX.LAYER5,
  className: '',
  style: {}
});
var PopperProvider = exports.PopperProvider = PopperContext.Provider;
var PopperConsumer = exports.PopperConsumer = PopperContext.Consumer;